import { IHighlightsFolder, ISegment } from '@/types/highlight.interface'

export const hasPartialSegmentOverlap = (
	newSegment: ISegment,
	existingSegment: ISegment
) => {
	const newStartsInsideExisting =
		newSegment.start > existingSegment.start &&
		newSegment.start < existingSegment.end &&
		newSegment.end > existingSegment.end

	const newEndsInsideExisting =
		newSegment.start < existingSegment.start &&
		newSegment.end > existingSegment.start &&
		newSegment.end < existingSegment.end

	return newStartsInsideExisting || newEndsInsideExisting
}

export const hasPartialOverlapInFolder = (
	folder: IHighlightsFolder | undefined,
	segment: ISegment
) => {
	if (!folder) return false

	return folder.segments.some(existingSegment =>
		hasPartialSegmentOverlap(segment, existingSegment)
	)
}

export const hasPartialOverlapInFolders = (
	folderIds: number[],
	segment: ISegment,
	folders: IHighlightsFolder[]
) => {
	return folders
		.filter(folder => folderIds.includes(folder.id))
		.some(folder => hasPartialOverlapInFolder(folder, segment))
}

export const hasSameSegment = (
	segment: ISegment,
	targetFolder?: IHighlightsFolder
) => {
	if (!targetFolder) return false

	return targetFolder.segments.some(
		existingSegment =>
			existingSegment.start === segment.start &&
			existingSegment.end === segment.end
	)
}
